/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_RootInputs */

const es_components_file_tree_root = /** @type {(inputs: Components_File_Tree_RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raíz`)
};

const en_components_file_tree_root = /** @type {(inputs: Components_File_Tree_RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Root`)
};

/**
* | output |
* | --- |
* | "Root" |
*
* @param {Components_File_Tree_RootInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_root = /** @type {((inputs?: Components_File_Tree_RootInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_RootInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_root(inputs)
	return en_components_file_tree_root(inputs)
});
export { components_file_tree_root as "components.file_tree.root" }